import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';

@Component({
  selector: 'edit-offline-node-dialog',
  templateUrl: './edit-offline-node-dialog.component.html',
  styleUrls: ['./edit-offline-node-dialog.component.scss']
})
export class EditOfflineNodeDialogComponent implements OnInit {

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  isCollapsed = true;
  transportTypeOptions = [{text: 'HTTP', value: 'HTTP'}, {text: 'HTTPS', value: 'HTTPS'}];
  teamsRoleOptions = [
    {text: 'Proxy', value: 'PROXY'},
    {text: 'Remote', value: 'REMOTE'},
    {text: 'Not Teams', value: 'NOT_TEAMS'}
  ];
  isAuthorized: boolean;
  operStateOptions = [{value: 1, text: 'UNAVAILABLE'}, {value: 15, text: 'AVAILABLE'}];

  constructor(public dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private userPrivilege: UserPrivilegeService) {
  }

  ngOnInit(): void {
    this.isAuthorized = this.userPrivilege.isAuthorized();
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    this.onApply.emit(this.data);
  }

  isLegacyGroup(): boolean {
    const serverGroup = this.data.routingServerGroups.find((group) => {
      return group.id === this.data.selectedItem.routingServerGroupId;
    });
    return !!serverGroup ? serverGroup.legacy : false;
  }
}
